import IframeTouchpointPreview from "containers/admin/clients/touchpoint/components/iframe-touchpoint-preview";
import { EmailHeaders } from "containers/admin/clients/touchpoint/components/email-builder/email-header-preview/email-header-preview";

import { useCurrentClient } from "hooks/api/use-clients";
import { useCurrentTouchpoint } from "hooks/api/use-current-touchpoint";

export interface DesignPreviewProps {
  /** Touchpoint `finalHtml`, already stripped of the user id. */
  htmlContent: string;
  htmlJSON: string;
  isCommentMode?: boolean;
  isFullContentMode?: boolean;
  mobileView?: boolean;
  emailHeaders?: EmailHeaders;
  hideSubjectAndPreheader?: boolean;
}

/**
 * The single decision point for how a touchpoint's `finalHtml` is rendered, so the creative preview tab and
 * both builder preview tabs can never drift onto different renderers.
 */
export const DesignPreview = ({
  htmlContent,
  htmlJSON,
  isCommentMode = false,
  isFullContentMode = false,
  mobileView = false,
  emailHeaders,
  hideSubjectAndPreheader,
}: DesignPreviewProps) => {
  const currentClient = useCurrentClient();
  const currentTouchpoint = useCurrentTouchpoint();

  return (
    <IframeTouchpointPreview
      htmlContent={htmlContent}
      htmlJSON={htmlJSON}
      isCommentMode={isCommentMode}
      isFullContentMode={isFullContentMode}
      mobileView={mobileView}
      emailHeaders={emailHeaders}
      hideSubjectAndPreheader={hideSubjectAndPreheader}
      touchpointName={currentTouchpoint.name}
      baseHref={currentClient.apolloDomainUrl}
    />
  );
};
